<div plyr class="w-full h-auto rounded-lg" [plyrTitle]="data.data.video_detail.video_title" 
  [plyrPlaysInline]="true"
  [plyrPoster]="poster" 
  [plyrSources]="videoSources" 
  (plyrInit)="player = $event" 
  (plyrPlay)="played($event)"
  (plyrPause)="paused($event)"
  (plyrEnded)="ended($event)"
  plyrType="video"
  [plyrOptions]="plyrOptions"
  (plyrSeeked)="seeked($event)"
  (plyrSeeking)="seeked($event)"
  (plyrTimeUpdate)="timeUpdate($event)"
  ></div>